export default __webpack_public_path__ + "static/media/luism3861.9019cd26.jpeg";